import {
	createUiActionType,
	createUiAction,
} from './util';

export const uiActionTypes = {
	QUESTION_DONE: createUiActionType('QUIZ/QUESTION_DONE'),
	NOTIFICATION: createUiActionType('NOTIFICATION'),
};

export const uiActions = {
	questionDone: questionId => createUiAction(uiActionTypes.QUESTION_DONE, { questionId }),
	notification: data => createUiAction(uiActionTypes.NOTIFICATION, data),
};



// WEBPACK FOOTER //
// ./src/actions/ui.js